import TopazLabs from '@lobehub/icons/es/TopazLabs/components/Mono';

export const stackCategories = [
  {
    title: 'DESIGN',
    tools: [
      { name: 'Figma',     description: 'Design Tool',                       logo: '/logos/figma.svg',  url: 'https://figma.com',                        phase: 'define develop' },
      // { name: 'Framer', description: 'Website Builder',                   logo: '/logos/framer.svg', url: 'https://framer.com' },
      { name: 'Adobe',     description: 'Professional Creative Software',    logo: '/logos/adobe.svg',  url: 'https://adobe.com',                        phase: 'develop' },
      { name: 'Pika',      description: 'Color Picker',                      logo: '/logos/pika.svg',   url: 'https://superhighfives.com/pika',           phase: 'develop' },
      { name: 'Tints.dev', description: 'Tailwind CSS Palette Generator',    emoji: '😗',               url: 'https://www.tints.dev/palette/v1:bGltZXw4NENDMTZ8MzAwfHB8MHwwfDB8MTAwfGE', phase: 'develop' },
      { name: 'Mobbin',    description: 'Design Patterns',                   logo: '/logos/mobbin-dark.svg', logoDark: '/logos/mobbin-light.svg', url: 'https://mobbin.com', phase: 'define' },
    ]
  },
  {
    title: 'CODE & AI',
    tools: [
      { name: 'Cursor',      description: 'Code Editor',              logo: '/logos/cursor.svg',                                                     url: 'https://cursor.sh',           phase: 'develop' },
      { name: 'Claude',      description: 'AI Assistant',             logo: '/logos/claude.svg',                                                     url: 'https://claude.ai',           phase: 'develop' },
      { name: 'ChatGPT',     description: 'AI Assistant',             logo: '/logos/chatgpt-dark.svg', logoDark: '/logos/chatgpt-light.svg',          url: 'https://chat.openai.com',     phase: 'define'  },
      { name: 'GitHub',      description: 'Version Control',          logo: '/logos/github.svg',                                                     url: 'https://github.com',          phase: 'deliver' },
      { name: 'Vercel',      description: 'Deployment',               logo: '/logos/vercel-dark.svg',  logoDark: '/logos/vercel-light.svg',           url: 'https://vercel.com',          phase: 'deliver' },
      { name: 'Midjourney',  description: 'AI Image Generation',      logo: '/logos/midjourney-dark.svg', logoDark: '/logos/midjourney-light.svg',    url: 'https://midjourney.com',      phase: 'develop' },
      { name: 'Topaz Labs',  description: 'AI Image & Video Upscaling', component: TopazLabs,                                                        url: 'https://topazlabs.com',       phase: 'develop' },
      { name: 'Supabase',    description: 'Backend & Database',         logo: '/logos/supabase.svg',                                                   url: 'https://supabase.com',        phase: 'develop' },
      { name: 'Google Flow', description: 'AI Filmmaking',              logo: '/logos/google-flow.png',                                                url: 'https://flow.google',         phase: 'develop' },
    ]
  },
  {
    title: 'PRODUCTIVITY',
    tools: [
      { name: 'Slack',            description: 'Collaboration',      logo: '/logos/slack.svg',            url: 'https://slack.com',               phase: 'define' },
      { name: 'Teams',            description: 'Collaboration',      logo: '/logos/teams.svg',            url: 'https://teams.microsoft.com',     phase: 'define' },
      { name: 'Google Workspace', description: 'Collaboration',      logo: '/logos/google-workspace.svg', url: 'https://workspace.google.com',    phase: 'define' },
      { name: 'Asana',            description: 'Project Management', logo: '/logos/asana.svg',            url: 'https://asana.com',               phase: 'define' },
      { name: 'Granola',           description: 'AI Meeting Notes',   logo: '/logos/granola.svg',          url: 'https://granola.ai',              phase: 'define' },
      { name: 'Spotify',          description: 'Music',              logo: '/logos/spotify.svg',          url: 'https://spotify.com',             phase: 'all' },
    ]
  }
];

export const phases = [
  {
    id: 'define',
    label: 'DEFINE',
    description: "Understand the problem, research patterns, align with expectations, identify what needs to be solved.",
  },
  {
    id: 'develop',
    label: 'DEVELOP',
    description: "Design systems in Figma, iterate fast with AI, refine until it feels right.",
  },
  {
    id: 'deliver',
    label: 'DELIVER',
    description: "Push to production, validate in the real world.",
  },
];
